// extracted by mini-css-extract-plugin
module.exports = {"skeletonContainer":"BookmarkedVersesListSkeleton_skeletonContainer__vreim","skeletonItem":"BookmarkedVersesListSkeleton_skeletonItem__YF8QK"};